/* eslint-disable sort-keys */
/* eslint-disable react/no-array-index-key */
/* eslint-disable import/no-cycle */
import React from 'react'

import { AccordionItemComponent, Image } from '../../components'
import AccordionsWrapper from '../../components/AccordionsWrapper/AccordionsWrapper'
import LinkComponent from '../../components/LinkComponent/LinkComponent'
import { Content, Heading, Kicker } from '../../components/Typography'
import useMediaQuery from '../../hooks/useMediaQuery'
import { useTreatmentCategories } from '../../hooks/useTreatmentCategories'
import SectionLayout from '../../layouts/SectionLayout/SectionLayout'
import { defaultLanguage } from '../../utils/appConfig'
import { ContentParser } from '../../utils/helpers'
import {
  contentPlacement,
  kickerLineHeight,
  navContainer,
  sectionContainer,
  titleClassName,
  treatmentItem,
  treatmentNav,
  treatments,
  treatmentsContainer,
  treatmentsImage,
  treatmentsList,
} from './TreatmentList.module.css'

const TreatmentsList = ({ lang, slice }) => {
  const { treatmentlistheading, treatmentlistkicker } = slice

  const treatmentsData = useTreatmentCategories()
  const localizedTreatmentsData = treatmentsData.filter(
    (item) => item.language.slug === lang,
  )
  const { treatmentcategorycontent } = localizedTreatmentsData[0]
  const treatmentCategories = ContentParser(
    treatmentcategorycontent,
    'treatmentcategory',
  ).filter((res) => res.treatments !== null)
  const isDesktop = useMediaQuery('(min-width: 1100px)')
  const accordionContent = []

  const scrollTo = (idx) => {
    accordionContent[idx].scrollIntoView({ behavior: 'smooth' })
  }

  return (
    <SectionLayout
      extraHeadingContainerClassName={contentPlacement}
      heading={treatmentlistheading}
      kicker={treatmentlistkicker}
      withHeader
    >
      <div className={sectionContainer}>
        <div className={navContainer}>
          {treatmentCategories.map((category, index) => {
            return (
              <div
                key={index}
                className={treatmentNav}
                onClick={() => scrollTo(index)}
                onKeyDown={() => scrollTo(index)}
                role="button"
                tabIndex="0"
              >
                <Kicker extraClassName={kickerLineHeight}>
                  {category.heading}
                </Kicker>
              </div>
            )
          })}
        </div>
        <div className={treatmentsList}>
          {treatmentCategories.map((category, index) => {
            return (
              <div
                key={index}
                ref={(ref) => {
                  accordionContent[index] = ref
                }}
                className={treatmentsContainer}
                id={`${category.heading}`}
              >
                {category.image && (
                  <Image
                    alt={category.image.altText || 'Kliniken Image'}
                    className={treatmentsImage}
                    src={category.image.node.localFile.childImageSharp}
                  />
                )}
                <Heading>{category.heading}</Heading>
                <Content renderContent={category.content} />
                <AccordionsWrapper className={treatments} isDesktop={isDesktop}>
                  {category.treatments?.nodes.map(
                    (treatment, treatmentIndex) => {
                      const title = treatment.pageType.name || treatment.title
                      const link =
                        lang === defaultLanguage.slice(0, 2)
                          ? `/${treatment.pageType.uri}/`
                          : `/${lang}/${treatment.pageType.uri}/`
                      return isDesktop ? (
                        <div key={treatmentIndex} className={treatmentItem}>
                          <Kicker>
                            <LinkComponent src={link}>{title}</LinkComponent>
                          </Kicker>
                        </div>
                      ) : (
                        <AccordionItemComponent
                          key={treatmentIndex}
                          active={false}
                          item={{ title, link }}
                          rotated
                          titleClassname={titleClassName}
                        />
                      )
                    },
                  )}
                </AccordionsWrapper>
              </div>
            )
          })}
        </div>
      </div>
    </SectionLayout>
  )
}

export default TreatmentsList
